export default __webpack_public_path__ + "static/media/menu-icon-notifications-black.5ca720ef.svg";